import {ref, access, html, clone, traverse, text, after, effect, on, each, append, css, define} from "@intrnl/velvet/internal";
import '~/style.css';
import dict from '~/assets/dict.json';
let template0 = html("<h3>wordle unscrambler</h3> <form> <label> <span>word to search (use ? for placeholders)</span> <input pattern=\"[a-z?]+\" maxlength=\"5\" /> </label> <label> <span>include letters</span> <input pattern=\"[a-z]+\" /> </label> <label> <span>exclude letters</span> <input pattern=\"[a-z]+\" /> </label> <button type=\"submit\">search</button> <button type=\"button\">reset</button> </form> <hr /> <span><!> results</span> <ul> <!> </ul>");
let template1 = html("<li><!></li>");
let style0 = css("h3,form,label{display:block;margin-top:0;margin-bottom:16px}label>span{display:block;margin-bottom:4px}input{width:-moz-available;width:-webkit-fill-available;width:fill-available;font-family:monospace;padding:8px}button{padding:8px;margin-right:8px}hr{color:transparent;border:0;border-bottom:1px solid #808080;margin:16px 0}ul{display:flex;flex-wrap:wrap;padding:0;gap:16px}li{display:block}");
function setup($$root, $$host) {
  let include = ref('');
  let exclude = ref('');
  let string = ref('');
  let results = ref([]);
  function search(ev) {
    ev.preventDefault();
    let matches = [...string(access)];
    let include_array = [...new Set(include(access))];
    let exclude_array = [...new Set(exclude(access))];
    results(dict.filter(word => {
      return (exclude_array ? !exclude_array.some(char => word.includes(char)) : true) && (include_array ? include_array.every(char => word.includes(char)) : true) && matches.every((char, idx) => char === '?' || word[idx] === char);
    }));
    include(include_array.join(''));
    exclude(exclude_array.join(''));
  }
  function reset() {
    include('');
    exclude('');
    string('');
    results([]);
  }
  let fragment0 = clone(template0);
  let child0 = traverse(fragment0, [2, 1, 3]);
  let child1 = traverse(fragment0, [2, 3, 3]);
  let child2 = traverse(fragment0, [2, 5, 3]);
  let child3 = traverse(fragment0, [2, 9]);
  let child4 = traverse(fragment0, [2]);
  let marker0 = traverse(fragment0, [6, 0]);
  let marker2 = traverse(fragment0, [8, 1]);
  let block1 = ($$root, item) => {
    let fragment1 = clone(template1);
    let marker1 = traverse(fragment1, [0, 0]);
    let child5 = traverse(fragment1, [0]);
    text(marker1, () => item(access));
    after($$root, fragment1);
    return child5;
  };
  effect(() => child0["value"] = string(access));
  on(child0, "input", () => string(child0.value));
  effect(() => child1["value"] = include(access));
  on(child1, "input", () => include(child1.value));
  effect(() => child2["value"] = exclude(access));
  on(child2, "input", () => exclude(child2.value));
  on(child3, "click", reset);
  on(child4, "submit", search);
  text(marker0, () => results(access).length);
  each(marker2, block1, () => results(access));
  append($$root, fragment0);
}
export default define("x-app", setup, {}, [style0]);
